import * as yup from 'yup';
import i18n from 'helpers/i18n';
import messages from './messages';
import RouteHelpers from 'helpers/routes';
import useAsync from 'hooks/useAsync';
import { useRef } from 'react';
import { FormikHelpers } from 'formik';
import { lookupUser } from 'actions/users';
import { Button, TextField } from '@teachstonellc/component-library';
import { useLoginManager } from 'components/LoginManager';
import { Formik } from 'components/EnhancedForm';
import FocusFirstInvalidField from 'components/FocusFirstInvalidField';
import { ButtonWrapper, SignOutIFrame } from './Styled';
import moment from 'moment';

const validationSchema = yup.object({
  search_text: yup
    .string()
    .required(() => i18n.ft(messages.errors.email.required))
});

function LoginLookup() {
  const { run, isLoading } = useAsync();
  const { setStep, setEmailOrPhone, emailOrPhone } = useLoginManager();
  const searchTextInputRef = useRef<HTMLInputElement>(null);

  function handleSubmit(values: any, formik: FormikHelpers<any>) {
    run(lookupUser(values), {
      onSuccess: (data: any) => {
        const emailOrPhone = data.email_or_phone;
        setEmailOrPhone(emailOrPhone);

        if (emailOrPhone.includes('@')) {
          setStep('loginWithPassword');
        } else {
          setStep('loginWithCode');
        }
      },
      onError: (error: any) => {
        let time = moment(error?.locked_until).fromNow(true);
        let errorMessage = Boolean(error?.locked_until)
          ? i18n.ft(messages.errors.tryAgainIn, { time })
          : error?.errors?.user_lookup?.[0];
        formik.setFieldError('search_text', errorMessage);
      }
    });
  }

  return (
    <Formik
      onSubmit={handleSubmit}
      initialValues={{ search_text: emailOrPhone }}
      validationSchema={validationSchema}
      validateOnBlur={false}
    >
      {formik => {
        const isError = Boolean(
          formik.touched.search_text && formik.errors.search_text
        );

        return (
          <form onSubmit={formik.handleSubmit} onReset={formik.handleReset}>
            <FocusFirstInvalidField
              submitCount={formik.submitCount}
              fields={[{ isInvalid: isError, inputRef: searchTextInputRef }]}
            />

            <TextField
              {...formik.getFieldProps('search_text')}
              ref={searchTextInputRef}
              autoFocus
              label={i18n.ft(messages.email)}
              placeholder={i18n.ft(messages.emailPlaceholder)}
              autoComplete="username"
              aria-invalid={isError}
              error={isError ? formik.errors.search_text : undefined}
            />

            <input
              name="password"
              tabIndex={-1}
              type="password"
              autoComplete="current-password"
              style={{ opacity: 0, height: 0, position: 'absolute' }}
            />

            <ButtonWrapper>
              <Button
                fullWidth
                variant="primary"
                shape="rounded"
                type="submit"
                loading={isLoading}
                disabled={isLoading}
              >
                {i18n.ft(messages.continue)}
              </Button>
            </ButtonWrapper>

            <SignOutIFrame
              title="single logout iframe"
              src={RouteHelpers.getPath('single-logout')}
            />
          </form>
        );
      }}
    </Formik>
  );
}

export default LoginLookup;
